/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize LossHepatitisImmunity List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './LossHepatitisImmunityView';

export const mapStateToPropsLossHepatitisImmunityList = mapStateToProps;
export const mapDispatchToPropsLossHepatitisImmunityList = mapDispatchToProps;

export default connect(
  mapStateToPropsLossHepatitisImmunityList,
  mapDispatchToPropsLossHepatitisImmunityList
)(View);
